(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-co-dzien-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ncd-product]').forEach((root) => {
    const main = root.querySelector('.ncd-main-media img');
    root.querySelectorAll('[data-ncd-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!main) return;
        main.src = button.dataset.src;
        main.srcset = '';
        main.alt = button.dataset.alt || '';
        root.querySelectorAll('[data-ncd-thumb]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
